import { render, staticRenderFns } from "./TournamentMenu.vue?vue&type=template&id=ce8b16d8&scoped=true&"
import script from "./TournamentMenu.vue?vue&type=script&lang=js&"
export * from "./TournamentMenu.vue?vue&type=script&lang=js&"
import style0 from "./TournamentMenu.vue?vue&type=style&index=0&id=ce8b16d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8b16d8",
  null
  
)

component.options.__file = "TournamentMenu.vue"
export default component.exports